export class PrintMovimentacaoRequest {
  public pesquisa?: string;
  public dataInicio?: string;
  public dataFim?: string;
  public idNaturezaMovimentacao?: number;
  public idContaFinanceira?: number;
  public idsCategoriaFinanceira?: number[];
  public idsTagsMovimentacao?: number[];
  public idsSituacaoMovimentacao?: number[];
}
